import { RouteAuthMechanism } from "../types";

export const ROUTE_AUTH_OPTIONS = Object.values(RouteAuthMechanism);

export const ROUTE_AUTH_LABELS: Record<RouteAuthMechanism, string> = {
  [RouteAuthMechanism.NONE]: "None",
  [RouteAuthMechanism.API_KEY]: "API key",
  [RouteAuthMechanism.BASIC]: "Basic",
  [RouteAuthMechanism.OAUTH2]: "OAuth 2",
  [RouteAuthMechanism.JWT]: "JWT",
  [RouteAuthMechanism.MUTUAL_TLS]: "Mutual TLS",
  [RouteAuthMechanism.CUSTOM]: "Custom",
};

export function routeAuthLabel(value: RouteAuthMechanism): string {
  return ROUTE_AUTH_LABELS[value] ?? value;
}
